module.exports = __webpack_public_path__ + "static/media/leaf-good.d88ccc4a.svg";